import { FormattedMessage } from 'react-intl';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export type InternalErrorStateProps = {
    reloadTriggerFunction?: () => void;
    additionalClassName?: string;
    innerClassName?: string;
    fullWidth?: boolean;
};

const InternalErrorState = ({
    reloadTriggerFunction,
    additionalClassName,
    innerClassName,
    fullWidth,
}: InternalErrorStateProps) => (
    <ErrorState
        headline={<FormattedMessage id="intl-msg:common.error.emptyState.headline" />}
        message={<FormattedMessage id="intl-msg:common.error.emptyState.message" />}
        buttons={[
            {
                text: <FormattedMessage id="intl-msg:common.error.emptyState.button" />,
                onClick: reloadTriggerFunction,
            },
        ]}
        // className should keep the original values plus the news values passed
        outerClassName={`${additionalClassName}`}
        innerClassName={innerClassName}
        fullWidth={fullWidth}
    />
);

export default InternalErrorState;
